export const config = {
  title: 'Agolli Construction | Construction and Design Services',
  meta: {
    description:
      'Agolli Construction is your trusted construction and design partner in Philadelphia, PA, USA. We specialize in construction, concrete laying, and design services tailored to your needs.',
    keywords: [
      'Construction Services Philadelphia',
      'Design Services Philadelphia',
      'Concrete Laying Philadelphia',
      'Agolli Construction',
      'Home Renovation Philadelphia',
    ],
    author: 'Agolli Construction',
    canonicalUrl: 'https://www.agolliconstruction.org/',
  },
  sections: {
    header: {
      businessName: 'Agolli Construction',
    },
    sectionB: {
      heroTitle: 'Agolli Construction',
      heroSubtitle: 'Building Trust, Delivering Excellence in Philadelphia, PA',
      learnAboutText: 'Explore Services',
      phoneNumber: '2679820515',
      phoneLabel: '(267) 982-0515',
      heroBackgroundImage:
        'https://media.istockphoto.com/id/918746438/photo/construction-residential-new-house-in-progress-at-building-site.jpg?s=612x612&w=0&k=20&c=o66U2sJO45ZgQ6gur4UKVqolyjb-cdXb8RC2PfenSo8=',
      cardData: [
        {
          title: 'High-Quality Workmanship',
          description:
            'Our team ensures that every project is executed with precision and care, meeting and exceeding client expectations.',
        },
        {
          title: 'Tailored Solutions',
          description:
            'We provide custom construction and renovation solutions designed to match your specific needs and vision.',
        },
        {
          title: 'Reliable Support',
          description:
            'Our commitment to transparency and open communication makes your project journey seamless and worry-free.',
        },
      ],
      description:
        'Agolli Construction offers a full suite of construction and design services to cater to your residential and commercial needs in Philadelphia, PA.',
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        'At Agolli Construction, we offer a range of services to ensure your construction and renovation projects are a success.',
      cards: [
        {
          title: 'Exterior Design',
          description:
            'We deliver stunning exterior designs for residential and commercial properties, ensuring durability and style.',
          imageSrc:
            'https://static.wixstatic.com/media/837583_0abc63865a5649f2a4dc0332cf6a573b~mv2.png/v1/fill/w_358,h_246,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/IMG_8907_HEIC.png',
          imageAlt: 'Exterior Design Services',
        },
        {
          title: 'Interior Design',
          description:
            'We specialize in creating elegant and functional interiors that align with your aesthetic and practical needs.',
          imageSrc:
            'https://static.wixstatic.com/media/837583_de5ffe462bd94d92bc113b8d917a30fc~mv2.png/v1/fill/w_358,h_246,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/IMG_7009_HEIC.png',
          imageAlt: 'Interior Design Services',
        },
        {
          title: 'Concrete Laying',
          description:
            'From driveways to commercial properties, our expert concrete services ensure a long-lasting foundation.',
          imageSrc:
            'https://static.wixstatic.com/media/837583_0cc98a395344409d9796cb1fbed3e38e~mv2.png/v1/fill/w_358,h_246,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/IMG_0235_heic.png',
          imageAlt: 'Concrete Laying Services',
        },
      ],
      otherServicesTitle: 'Other Services',
      otherServicesList: [
        'Countertop Sink Installation',
        'Bathroom Renovations',
        'Pool Tile Work',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://static.wixstatic.com/media/837583_6429791b60124f0aa088d85773aed066~mv2.png/v1/fill/w_616,h_625,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/837583_6429791b60124f0aa088d85773aed066~mv2.png',
        alt: 'Agolli Construction Team',
      },
      aboutText: [
        'Agolli Construction is a trusted name in Philadelphia, PA, providing exceptional construction and design services for residential and commercial projects.',
        'With years of expertise, we ensure that every project we undertake is completed to the highest standards of quality and efficiency.',
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: 'Agolli Construction Logo',
      businessName: 'Agolli Construction',
      contact: {
        phone: '2679820515',
        phoneLabel: '(267) 982-0515',
        email: 'veagollli@agolliconstruction.org',
        website: 'https://www.agolliconstruction.org/',
        address: 'Philadelphia, PA, USA',
      },
      socialMedia: {
        googlePlus: null,
        linkedIn: null,
        facebook: null,
        twitter: null,
        tiktok: null,
        instagram: null,
        youtube: null,
      },
    },
    sectionF: {
      address: 'Philadelphia, PA, USA',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3058.5760110136727!2d-75.16522188467577!3d39.952583979423!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMznCsDU3JzA5LjMiTiA3NcKwMDknNTguNCJX!5e0!3m2!1sen!2sph!4v1614123456789!5m2!1sen!2sph',
    },
  },
};

export default config;
